import {Field, reduxForm, change} from 'redux-form'
import styles from './LibraryInventoryAlertModal.css'
import SettingField from 'components/Fields/ReduxForm/SettingField'
import validator from 'validator'

const validate = (values) => {
  const errors = {}
  if (values.stock_alert === '') {
    errors.stock_alert = 'The stock alert is required'
  } else if ((values.stock_alert.length > 1) && !(validator.isDecimal(values.stock_alert))) {
    errors.stock_alert = 'Please enter a valid number'
  }
  return errors
}

class LibraryInventoryForm extends React.Component {
  render () {
    let {libraryForm, units} = this.props

    return (
      <form id='form-library-inventory'>
        <table className={`table table-responsive ${styles.table}`}>
          <thead>
            <tr>
              <th>Ingredient</th>
              <th>Track Stock</th>
              <th>In Stock</th>
              <th>Alert</th>
              <th>Alert at</th>
              <th>Unit</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className={`${styles['text-elipsis']}`}><span name='name'>{libraryForm && libraryForm.name}</span></td>
              <td>
                <div>
                  <div className='checkbox checkbox-primary checkbox-item checkbox-circle checkbox-grey'>
                    <input type='checkbox' checked='true' disabled='true' />
                    <label for='' />
                  </div>
                </div>
              </td>
              <td>
                <div className='form-group'>
                  <Field
                    component='input'
                    name={`in_stock`}
                    type='text'
                    className='form-control'
                    readOnly={libraryForm ? !!libraryForm.id : true}
                    onChange={this._setDecimal}
                  />
                </div>
              </td>
              <td>
                <div className='checkbox checkbox-primary checkbox-item checkbox-circle'>
                  <Field
                    component='input'
                    name={`alert`}
                    type='checkbox'
                    id={`checkbox-alert-ingredient`}
                  />
                  <label for={`checkbox-alert-ingredient`} />
                </div>
              </td>
              <td>
                <div className='form-group'>
                  <Field
                    component={SettingField}
                    name={`stock_alert`}
                    type='text'
                    className='form-control'
                    positiveNumberOnly
                    maxFractionDigits={2}
                  />
                </div>
              </td>
              <td>
                {libraryForm && libraryForm.unit_id ? units.find(unit => parseInt(unit.id) === parseInt(libraryForm.unit_id)).name : ''}
              </td>
            </tr>
          </tbody>
        </table>
      </form>
    )
  }

  _setDecimal = (event) => {
    let nextVal = event.target.value
    const maxFractionDigits = 2
    if (isNaN(nextVal)) {
        // case if one digit < 0 integer
      if (nextVal === '-') {
        this.props.dispatch(change('libraryInventory', 'in_stock', ''))
      } else {
          // no op. invalid change
      }
    } else if (maxFractionDigits !== undefined) {
      const dotPosition = nextVal.indexOf('.')
      if (dotPosition !== -1 && nextVal.length - dotPosition - 1 > maxFractionDigits) {
          // no op. invalid change
      } else {
        this.props.dispatch(change('libraryInventory', 'in_stock', nextVal))
      }
    } else {
      this.props.dispatch(change('libraryInventory', 'in_stock', nextVal))
    }
    event.preventDefault()
  }
}

LibraryInventoryForm.propTypes = {
  libraryForm: React.PropTypes.object,
  units: React.PropTypes.array
}

export default reduxForm({
  form: 'libraryInventory',  // a unique identifier for this form,
  touchOnBlur: false,
  touchOnChange: true,
  validate
})(LibraryInventoryForm)



// WEBPACK FOOTER //
// ./app/pages/Ingredient/Library/LibraryDetail/LibraryForm/LibraryInventoryAlertModal/LibraryInventoryForm.js